import { type ReactNode, Suspense } from "react";

// project imports
import Spinner from "src/views/spinner/Spinner";

// ===========================|| LOADABLE - LAZY LOADING ||=========================== //

const Loadable =
  (Component: any, spinner: ReactNode = <Spinner />) =>
  (props: any) => (
    <Suspense fallback={spinner}>
      <Component {...props} />
    </Suspense>
  );

export default Loadable;
